import { logs } from './log-endpoints';

export const v1 = {
  logs,
};
